exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_playlists_165DCY75dZnmSDVc85wHNn {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_1Lli5fWxzDOSDaZQqlhs48 {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_1vjXVIlW8-u_2QNvfKlzfn {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_Gwm4-FJrNKy4u7QpOJ4lY {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_playlists": "IA_playlists_165DCY75dZnmSDVc85wHNn",
	"IA_filters": "IA_filters_1Lli5fWxzDOSDaZQqlhs48",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_1vjXVIlW8-u_2QNvfKlzfn",
	"IA_paginationPageCount": "IA_paginationPageCount_Gwm4-FJrNKy4u7QpOJ4lY"
};